import React, { DetailedHTMLProps, RefObject } from 'react';
import styled, { css } from "styled-components";
import { FormFieldStyles } from './Layout';

interface ContainerProps {
  error: boolean;
}

const Container = styled.div<ContainerProps>`
  input {
    ${FormFieldStyles};
  }

  ${({ error }) => error && css`
    input {
      border-color: red;
    }
  `}
`;

const Input = styled.input`
  
`;

interface OwnProps {
  controlRef?: RefObject<HTMLInputElement>;
  error?: boolean;
  containerStyle?: React.CSSProperties;
  onValueChange: (value: string) => void;
}

type Props = OwnProps & DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export default function TextField(props: Props) {
  const { containerStyle, controlRef, error = false, onValueChange, ...inputProps } = props;

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onValueChange(event.target.value);
  };

  return (
    <Container error={error}>
      <input
        ref={controlRef}
        onChange={handleOnChange}
        {...inputProps}
      />
    </Container>
  );
}